import React from 'react'

const UpAndDown = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3002_8552)">
        <path
          d="M3 8L6.77294 12.3119C7.09167 12.6762 7.65833 12.6762 7.97706 12.3119L11.75 8"
          fill="#873BFF"
        />
        <path
          opacity="0.3"
          d="M11.75 5L7.97706 0.688069C7.65833 0.323808 7.09167 0.323808 6.77294 0.68807L3 5"
          fill="#667085"
        />
      </g>
      <defs>
        <clipPath id="clip0_3002_8552">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UpAndDown